import {
  SET_BACK_ROUTE,
  SET_BACK_ROUTE_OVERRIDE
} from './actions'
// Deprecate use src/app/router/store/index.js
const mutations = {
  [SET_BACK_ROUTE]: (state, value) => {
    state.routeBack = value
  },
  [SET_BACK_ROUTE_OVERRIDE]: (state, value) => {
    state.routeBackOverride = value
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/app/appLogic/route/store/mutations.js